import { Controller } from "stimulus"
import $ from 'jquery';
import { warningIcon } from "../src/shared/icons";

export default class extends Controller {
  static targets = ['form', 'content', 'photo', 'previewPhoto', 'previewPhotoSection', 'file', 'previewFile', 'previewFileSection', 'submit', 'error', 'errorMessage']

  showForm() {
    $(this.formTarget).fadeIn(500)
  }

  hideForm() {
    $(this.formTarget).fadeOut(500)
  }

  photoHandler() {
    var file = this.photoTarget.files[0]
    if (file) {
      const photoPreview = this.previewPhotoTarget
      const reader = new FileReader()

      reader.onload = () => {
        photoPreview.src = reader.result
      }

      reader.readAsDataURL(file)
      this.showPhoto()
    }
  }

  showPhoto() {
    $(this.previewPhotoSectionTarget).fadeIn(500)
  }

  removePhoto() {
    $(this.previewPhotoSectionTarget).fadeOut(500)
    this.photoTarget.value = ''
  }

  fileHandler() {
    const file = this.fileTarget.files[0]

    if (file) {
      $(this.previewFileTarget).html(file.name)

      this.showFile()
    }
  }

  showFile() {
    $(this.previewFileSectionTarget).fadeIn(500)
  }

  removeFile() {
    $(this.previewFileSectionTarget).fadeOut(500)
    this.fileTarget.value = ''
  }

  setSubmitButton(text, disabled) {
    const submitTarget = this.submitTarget

    $(submitTarget).text(text)
    $(submitTarget).prop('disabled', disabled)
  }

  createForm() {
    const formData = new FormData(this.element)
    formData.append('community_post[socket_id]', window.socket.id)
    return formData
  }

  resetForm() {
    this.element.reset()
    this.setSubmitButton('Post', false)
    this.errorMessageTarget.innerHTML = ''
    $(this.errorTarget).removeClass('has-error')
    this.removeFile()
    this.removePhoto()
    this.hideForm()
  }

  sendPost(formData) {
    this.setSubmitButton('Posting...', true)

    $.ajax({
      type: 'POST',
      url: '/posts',
      data: formData,
      cache: false,
      contentType: false,
      processData: false,
      success: data => {
        this.resetForm()
      },
      error: data => {
        this.setSubmitButton('Post', false)
        this.errorMessageTarget.innerHTML = data.responseJSON.error
        $(this.errorTarget).addClass('has-error')
      }
    })
  }

  submit(e) {
    e.preventDefault()
    const $form = this.element
    const formData = this.createForm()
    const newsFeedWarning = $($form).data('news-feed-warning')
    const userType = $($form).data('current-user-type')
    const whitelabel = document.body.getAttribute('data-whitelabel') == 'true'
    const icon = whitelabel ? '' : warningIcon
    const type = whitelabel ? 'warning' : ''

    if (newsFeedWarning && userType == 'Resident') {
      swal(
        {
          type: type,
          imageUrl: icon,
          imageSize: '150x150',
          title: 'Hold On...',
          text:
            "<p>Please click <strong>Send to Staff</strong> instead of <strong>Post To Wall</strong></p><p>if this post is a community concern or issue.</p><a href='#' onclick='swal.close()' id='close-swal'>Cancel</a>",
          showCancelButton: true,
          confirmButtonText: 'Post to Wall',
          cancelButtonText: 'Send to Staff',
          closeOnConfirm: true,
          closeOnCancel: false,
          html: true,
          allowEscapeKey: false
        },
        isConfirm => {
          if (isConfirm) {
            this.sendPost(formData)
          } else {
            $.ajax({
              type: 'POST',
              url: '/posts/send_email',
              dataType: 'json',
              data: formData,
              cache: false,
              contentType: false,
              processData: false,
              success: data => {
                this.resetForm()
                swal({
                  title: 'Thank You!',
                  text:
                    "Your concern/issue has been emailed to the community's staff.",
                  type: 'success'
                })
              },
              error: data => {
                this.resetForm()
                swal({
                  title: 'Oops...',
                  text: data.responseJSON.error,
                  type: 'error'
                })
              }
            })
          }
        }
      )
    } else {
      this.sendPost(formData)
    }
  }
}
